import { WORKS } from '../mock';

export default function Investment() {
  return (
    <section className="bg-[#0d281e] text-[#f1ede5] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <span className="eyebrow">Investment in Quality</span>
            <div className="mt-10">
              <div className="font-serif-display text-[64px] leading-none">Over</div>
              <div className="font-serif-display text-[#b39352] text-[180px] md:text-[220px] leading-[0.9] tracking-tight">
                &pound;1m
              </div>
              <div className="font-serif-display italic text-[22px] text-[#f1ede5] -mt-2">being invested</div>
            </div>
            <p className="mt-12 text-[14px] leading-[1.85] text-[#f1ede5]/75 max-w-md">
              Comprehensive works to create one of West Yorkshire&apos;s most distinctive commercial
              destinations — where heritage meets uncompromising modern specification.
            </p>
          </div>

          <div>
            <span className="eyebrow">The Works</span>
            <div className="mt-8">
              {WORKS.map((w, i) => (
                <div key={w} className="flex items-center gap-6 py-5 border-t border-[#f1ede5]/12 last:border-b">
                  <span className="font-serif-display text-[13px] text-[#b39352]">{String(i + 1).padStart(2, '0')}</span>
                  <span className="text-[15px] text-[#f1ede5]">{w}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
